import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/university/tuners/$tunerId')({

}).lazy(() => import('./$tunerId.lazy').then((d) => d.Route));
